import { Component } from '@verndale/core';

class ProductCatalog extends Component {

  constructor(el: HTMLElement) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      filtersContainer: this.el.querySelector<HTMLElement>('.product-catalog__filters'),
      closeFilters: this.el.querySelector<HTMLElement>('.product-catalog__close-link'),
      openFilters: this.el.querySelector<HTMLElement>('.product-catalog__open-link'),
      sortSelect: this.el.querySelector<HTMLSelectElement>('.product-catalog__sort-select')
    };
  }

  addListeners() {
    (this.dom.closeFilters as HTMLElement)?.addEventListener('click', this.closeFilters.bind(this));
    (this.dom.openFilters as HTMLElement)?.addEventListener('click', this.openFilters.bind(this));
    (this.dom.sortSelect as HTMLSelectElement)?.addEventListener('change', this.sortProducts.bind(this));
  }

  closeFilters() {
    (this.dom.filtersContainer as HTMLElement)?.classList.remove('open');
  }

  openFilters() {
    (this.dom.filtersContainer as HTMLElement)?.classList.add('open');
  }

  sortProducts(e: Event) {
    const target = e.target as HTMLSelectElement;
    const value = target.value;

    if (value) {

      const url = new URL(window.location.href);
      const cleanValue = value.split(' ').join('');
      url.searchParams.set('s', cleanValue);
      window.location.href = url.toString();
    }
  }

}

export default ProductCatalog;
